// Cookie banner
const notificationStorage = localStorage.getItem('pushsticky')
const notificationStickyBanner = document.getElementById('js-pushSticky');
const closeNotificationSticky = document.querySelectorAll('.js-pushStickyClose');

if(localStorage.getItem('pushsticky')) {
    notificationStickyBanner.classList.add('push-sticky--close')
}

function closeNotificationStickyBanner() {
    notificationStickyBanner.classList.add('push-sticky--hide')
    localStorage.setItem('pushsticky', 'close')
    setTimeout(() => {
        notificationStickyBanner.classList.remove('push-sticky--hide')
        notificationStickyBanner.classList.add('push-sticky--close')
    }, 500);
}

closeNotificationSticky.forEach(function (item) {
    item.addEventListener('click', closeNotificationStickyBanner, false)
});
